import React, { useEffect, useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import { dateToString, timestampToDate } from '../../utils/DateUtil';

function TriviaState(props) {
  const { profile } = props;
  const firestore = useFirestore();
  const [enableTrivia, setEnableTrivia] = useState(true);

  useEffect(() => {
    const unsuscribe = firestore
      .collection('userTrivia')
      .doc(profile.id)
      .onSnapshot(
        (snapshot) => {
          if (snapshot.exists) {
            const userTrivia = snapshot.data();
            const answerDate = userTrivia.answerDate;
            const dateFinish = timestampToDate(answerDate);
            if (dateFinish === dateToString(new Date())) {
              setEnableTrivia(false);
            } else {
              setEnableTrivia(true);
            }
          }
        },
        (e) => console.log(e.message),
      );

    return () => {
      unsuscribe();
    };
  }, [firestore, profile]);

  return (
    <div>
      {enableTrivia ? (
        <div>
          <span className="green white-text">Trivia Enabled</span>
        </div>
      ) : (
        <div>
          <span className="red white-text">Trivia Disable</span>
        </div>
      )}
    </div>
  );
}

export default TriviaState;
